import { styled } from 'stitches.config'

export const ViewAllProductsRoot = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: '$tertiary-200',
    gap: '$2',
    position: 'relative',
    paddingBottom: '$5',
    paddingTop: '$4',
    maxWidth: '200px',
    margin: 'auto',
    '@bp3': {
        maxWidth: '100%',
        paddingTop: 0,
    }
})

export const Blob1 = styled ('div', {
    position: 'absolute',
    top: '-20px',
    left: 0,
    width: '200px',
    display: 'none',
    '@bp3': { display: 'block' },
})

export const Blob2 = styled('div', {
    position: 'absolute',
    top: '-100px',
    right: 0,
    width: '200px',
    display: 'none',
    '@bp3': { display: 'block' },
})

export const Spacer = styled('div', {
    height: '40px'
})